/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    makeAsyncReducer,
    asyncDefaults,
    mergeReducers,
} from 'ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';
import { FacilityDefaults } from '../props';

const fetchFacility = makeAsyncReducer(types.FETCH_FACILITY);

const facility = mergeReducers(
    asyncDefaults(FacilityDefaults),
    types.PP_PREFIX,
    fetchFacility
);

export default facility;

export const selectors = {
    getFacility: (state) => state.parkpass.facility.data,
};
